import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BdsSupplierComponent } from './bds-supplier.component';

@NgModule({
    declarations: [BdsSupplierComponent],
    imports: [CommonModule],
})
export class BdsSupplierModule {}
